import { useMutation } from '@tanstack/react-query';
import { apiRequest } from '@/lib/apiClient';
import { useSelectionStore } from '@/state/selectionStore';

export type PublishResult =
  | { published_at: number; version_id: number }
  | { status: 'pending_approval'; request_id: number };

export function isPendingApproval(
  r: PublishResult,
): r is { status: 'pending_approval'; request_id: number } {
  return (r as { status?: string }).status === 'pending_approval';
}

export function usePublish() {
  const template = useSelectionStore((s) => s.template);
  return useMutation({
    mutationFn: async () => {
      const res = await apiRequest<PublishResult>('/api/sections/publish', {
        method: 'POST',
        body: { template },
      });
      return res;
    },
  });
}
